import { useMemo } from 'react'
import Box from 'components/shared/Box'
import { useAppSelector } from 'store/hooks'
import PromoCode from 'routes/OrderAndPayment/sections/PlaceOrderSection/components/PromoCode'
import { useVouchersContent } from 'utils/hooks/useVouchersContent'

interface PromotionBoxProps {
    hasPromoCodeField?: boolean
    hasCardVoucherLabel?: boolean
}

export const PromotionBox = ({
    hasPromoCodeField = true,
    hasCardVoucherLabel,
}: PromotionBoxProps) => {
    const { cart } = useAppSelector((state) => state.cart)
    const { giftCards } = cart || {}
    const vouchersContent = useVouchersContent({})

    const content = useMemo(() => {
        const hasCartPromotion = cart?.promotionCouponCode
        const hasGiftCard = giftCards && giftCards.length > 0
        const hasVouchers = vouchersContent?.vouchers

        return (
            <>
                {!!hasCartPromotion && (
                    <PromoCode hasCardVoucherLabel={hasCardVoucherLabel} />
                )}
                {hasGiftCard && !hasCartPromotion && hasVouchers}
                {hasPromoCodeField && !hasCartPromotion && (
                    <PromoCode hasCardVoucherLabel={hasCardVoucherLabel} />
                )}
                {(!!hasCartPromotion || !hasGiftCard) && hasVouchers}
            </>
        )
    }, [cart, giftCards, vouchersContent])

    return (
        <Box mb={[40, 32]} gap={16} style={{ gap: '16px' }}>
            {content}
        </Box>
    )
}
